import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/cgfns.css';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import useAuth from '../azureLogin/useAuth';
import { useLocation } from 'react-router-dom';
import CommentModal from './commentModal';
import {Table,Button } from 'react-bootstrap';
import { FaInfoCircle, FaArrowLeft } from 'react-icons/fa';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SFLink from '../azureLogin/SFLink';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { useMediaQuery } from 'react-responsive';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
}


const formatDate = (isoString) => {
  const date = new Date(isoString);
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
};

const CompStatusTracker = ({isICD}) => {
  const portal = isICD===true ? 'icd' : 'applicantPortal';
  const { t, i18n } = useTranslation();
  const [error, setError] = useState(null);
  const { token,fetchData } = useAuth();
  const [data, setData] = useState([]);
  const [percentapi, setPercentApi] = useState([]);
  const [filter, setFilter] = useState('All Requirements');
  const query = useQuery();
  const applicationID = query.get('applicationID');
  const ExtStatus = query.get('ExtStatus');
  const [category, setCategory] =useState('') ;
  const [mobilePage, setMobilePage] =useState(1) ;
  const sortOrder  =useState({});
  //populate modal
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const populateCommentModal = (event) => {
    const commentText = event.target.name;
    setModalContent(commentText);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  //end populate mmodal

  useEffect(() => {
    const fetchDetails = async () => {
       

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json'
        }
      };

      try {
        
        const url = `/AvailableApplication/${applicationID}/Requirements?fields=Id%2CName%2CCreatedById%2CLastModifiedById%2CStatus__c%2CAvailableApplication.Id%2CData_Doc_Comments__c%2CDataDoc.Id%2CDataDoc.Box_Folder_ID__c%2CshowFurtherActionRquired__c%2CshowNoFurtherActionRequiredIcon__c%2Cshow_copies_of_diploma_upload_button__c%2CshowUnderReviewIcon__c%2CProvided_Start_Date__c%2CProvided_End_Date__c%2CAvailableApplication.External_Status__c%2CELP_Testing_Waiver__c%2CApplicant_Request_Waiver__c%2CLanguage_Proficiency_Exam__c.Id%2CIs_Diploma_Requirement__c%2CBox_URL__c%2CAvailableApplication.RuleName__c%2CDataDoc.Name%2CProvided_Name_of_authority__c%2CAcceptance_Criteria_Comments__c%2CRequirement_Percentage__c%2CRequirement_Category__c.Name%2CRejection_Text__c%2CProvided_Name_of_Institution__c%2CName_of_Requirement__c%2CLink_to_form__c%2CApplicant_to_re_generate_form__c%2CRequirementCategory.Category_Type__c%2CRequirement_Type__c%2CAva_App_Portal_Code__c%2CDataDoc.Data_Doc_Type__c%2CDataDoc.Data_Doc_Status__c%2CProvided_Name_of_Credential_Awarded__c%2CProvided_Professional_Title_In_English__c%2CExternal_Status__c%2CDataDoc.Document_Received__c%2CSelf_Attestation__c%2CLicenseRegistration.Applicant_Directions__c%2CProgram_Name__c%2CEducationHistory.Applicant_Directions__c%2CLanguageProficiencyExam.I_Understand_Test_Scores__c%2CName_of_Requirement__c%2CDataDoc.Box_Shared_Folder_Link_For_Folder__c%2COther_Check__c%2CRejecting_Requirement_for_Other_Reason__c%2CDataDoc.Self_Attestation__c%2CAcceptanceCriterias.Accepted_Name_of_Institution__c%2CAcceptanceCriterias.Education_Data_Doc_Type__c%2CAcceptanceCriterias.WaitingforAllRequiredItems__c%2CAcceptanceCriterias.Education_Data_Doc_AC_Waived__c%2CEligible_for_Education_Waiver__c%2CReason_for_waiver__c%2CRequirementCategory.Total_Requirement__c%2CRequirementCategory.Completed_Requirements__c%2CAcceptanceCriterias.Data_Doc.Display_Self_Attestation_Button__c%2CFurther_Actions_Required__c%2CAcceptanceCriterias.Applicant_to_re_generate_form__c%2CAcceptanceCriterias.Data_Doc.Box_Shared_Folder_Link_For_Folder__c%2CAcceptanceCriterias.Rule_Name__c%2CAcceptanceCriterias.showUnderReviewIcon__c%2CAcceptanceCriterias.showNoFurtherActionRequiredIcon__c%2CAcceptanceCriterias.showFurtherActionRquiredIcon__c%2CAcceptanceCriterias.Link_to_form__c%2CAcceptanceCriterias.Data_Doc.Id%2CAcceptanceCriterias.Data_Doc__c%2CAcceptanceCriterias.Id`;
        
        const response = await fetchData(url,config);
        setData(response?.data?.sort((a, b) => {
          const indexA = sortOrder[a.RequirementCategory.Category_Type__c] ?? Infinity;
          const indexB = sortOrder[b.RequirementCategory.Category_Type__c] ?? Infinity;
          return indexA - indexB;
        }));
        console.log(response?.data);
      } catch (error) {
        setError(error);
      }
    };

    fetchDetails();
  }, [token,applicationID]);

  //callout for Percentage calculation
  useEffect(() => {
    const fetchDetails = async () => {
       

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json'
        }
      };

      try {
        const url= `/AvailableApplication/${applicationID}/RequirementCategory?fields=Id%2CTotal_Requirement__c%2CCompleted_Requirements__c`;
        
        const response = await fetchData(url,config);
        setPercentApi(response?.data);
        console.log("api resonse", response?.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDetails();
  }, [token,applicationID]);
  
  useEffect(() => {

    setData(data);
  }, [data]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!data) {
    return <div>Loading...</div>;
  }


  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setCategory(newFilter);
    setMobilePage(newFilter ==='' ? 1 :2);
  };

  const filteredData = filter === 'All Requirements'
    ? data
    : data?.filter((item) => item.RequirementCategory.Category_Type__c === filter);


  if (error) {
    return <div>Error: {error.message}</div>;
  }
  const SucessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16" style={{ color: 'green' }}>
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"></path>
    </svg>
  );
  const WarningIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16" style={{ fill: 'gold', height: '30px' }}>
      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
    </svg>
  );

  const ActionRequiredIcon = () => (
    <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-dash-circle" viewBox="0 0 16 16" style={{ fill: 'darkred', backgroundColor: 'pink', height: '20px' }}>
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
    </svg>
  );
  const  EducationHistory = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="M499 511c-15 1-29-5-44-10l-236-79-13-7c-5-4-5-9 0-13 4-3 9-6 14-7l252-76c19-6 38-6 58 0l250 75 15 7c6 4 6 10 0 14l-12 6-251 83c-11 5-21 7-33 7zm-166 4c-12-3-15 5-15 11v95c0 11 4 18 11 25l9 7c20 14 43 23 67 29a363 363 0 0 0 234-16c13-6 25-13 34-23 6-6 9-12 8-21l1-92c0-17-12-15-17-14l-133 44c-22 7-43 7-65 0zm416-29c-4 1-5 3-5 7v84l-2 9-18 45c-5 14-2 28 8 39l11 10c4 3 10 5 15 6 9 1 16-4 22-9l9-9c7-9 9-22 6-34-4-17-11-32-19-47-2-3-3-7-3-10v-92c0-6-5-5-7-4z" />
    </svg>
  );
  const EmploymentHistory = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="M307 481a213 213 0 1 1 424 43c-10 92-97 179-190 188-69 7-134-18-179-68-6-7-14-11-21-1l-23 28c-5 6-1 10 4 15a271 271 0 1 0-72-205l-1 10h-44c-13 0-19 15-12 23l73 88c6 7 16 7 22 0l73-88c8-10 1-23-12-23h-43zm214-100c-65 0-119 54-119 119s54 119 119 119 119-54 119-119-53-119-119-119zm95 107h-31c-1-28-8-53-17-71 26 14 44 41 48 71zm-106-78v78h-27c1-37 13-66 27-78zm0 102v78c-13-11-25-41-27-78zm23 78v-78h27c-1 37-13 66-27 78zm0-102v-78c13 11 25 41 27 78zm-57-71c-10 19-15 43-17 71h-31c3-30 21-57 48-71zm-49 95h31c1 28 8 53 17 71a95 95 0 0 1-48-71zm140 71c10-19 15-43 17-71h31c-3 30-21 57-48 71z" />
    </svg>
  );
  const LicensureOrRegistration = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="M740 290H260c-33 0-60 27-60 60v290c0 33 27 60 60 60h480c33 0 60-27 60-60V350c0-33-27-60-60-60zM486 630H314c-19 0-34-21-34-41 1-30 32-48 65-63 23-10 26-19 26-29s-6-19-14-26a68 68 0 0 1-21-50c0-38 23-70 63-70s63 32 63 70c0 20-7 38-21 50-8 7-14 16-14 26s3 19 26 28c33 14 64 34 65 64 2 20-13 41-32 41zm234-70c0 11-9 20-20 20h-90c-11 0-20-9-20-20v-30c0-11 9-20 20-20h90c11 0 20 9 20 20v30zm0-110c0 11-9 20-20 20H550c-11 0-20-9-20-20v-30c0-11 9-20 20-20h150c11 0 20 9 20 20v30z" />
    </svg>
  );
  const LanguageProficiency = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="M799 779c-3-41-4-83-4-124l1-62c0-19 2-38-5-56-16-41-70-49-109-49a247 247 0 0 0-100 23l13 32c3 6 4 13 5 19 26-12 52-19 78-19 41 0 61 16 61 48v15l-29-1c-52 0-91 8-119 23-27 16-41 43-41 82 0 29 9 52 27 68s41 24 68 24c24 0 44-3 59-10s28-17 38-31h2l5 34h50zm-59-101c0 7-1 14-4 21-2 5-4 10-8 15a84 84 0 0 1-53 30c-13 2-25 1-38-1-10-2-20-7-25-16-9-14-7-36 3-49 6-8 15-13 24-16 25-8 54-8 79-8l22 1zM549 563 407 211c-2-7-8-11-15-11h-45c-7 0-14 5-16 11L201 563c-3 7 2 15 9 15h50c7 0 14-6 16-13l33-92h128l37 92c2 7 9 13 16 13h49c8 0 14-8 10-15zM335 404l37-96 41 96z" />
    </svg>
  );
  const IdentityDocuments = () => (
    <svg className="float-end"  xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="M800 712v28c0 33-27 60-60 60H260c-33 0-60-27-60-60v-28c0-73 85-117 165-152l8-4c6-3 13-3 19 1a196 196 0 0 0 216 1c6-4 13-4 19-1l8 4c80 34 165 78 165 151z" /><ellipse cx="500" cy="365" rx="149" ry="165" /></svg>
  );
  const SpecialtyCertification = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="m773 557-73-108v-9a241 241 0 0 0-297-233 239 239 0 0 0-183 233c0 49 12 93 36 127 42 60 70 108 53 173-4 15-1 30 9 42 9 12 22 18 37 18h197c23 0 43-16 47-38l2-12c2-12 12-20 24-20h14c22 0 41-13 47-34 6-23 14-56 15-96h52c9 0 18-8 22-16s3-21-2-27zM614 420c-8 13-24 20-47 20-123 0-132 90-132 133 0 20-16 37-36 37h-3c-17 0-31-12-35-29-4-18-16-28-28-37-8-6-16-12-20-21a168 168 0 0 1 146-252c68 0 129 41 155 103 1 3 12 27 0 46z" />
    </svg>
  );
  const Portfolio = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 1000 1000" fill="currentColor" style={{ fill: 'gold', height: '32px' }}>
      <path d="M367 524c-17-27-27-59-27-94 0-59 25-109 65-139a83 83 0 0 0-75-41c-58 0-90 46-90 100 0 29 10 53 29 71 11 10 20 23 20 37s-5 26-38 40c-47 21-90 48-91 92 0 29 19 50 46 50h43c7 0 14-4 17-10 21-38 60-62 93-78 11-5 15-18 8-28zm382-26c-33-14-38-27-38-40 0-14 9-27 20-37 19-18 29-42 29-71 0-54-32-100-90-100-35 0-60 16-75 41 40 30 65 79 65 139 0 35-9 67-27 94-7 10-3 23 8 29 33 16 72 40 93 78 3 6 10 10 17 10h43c27 0 46-21 46-50-1-44-44-72-91-93zm-162 96c-36-15-41-29-41-44s10-30 22-41c21-19 33-47 33-79 0-59-36-110-100-110s-100 51-100 110c0 32 12 59 33 79 12 11 22 26 22 41s-6 29-41 44c-54 22-104 48-105 96 0 32 23 60 53 60h274c30 0 53-28 53-60-1-48-51-74-103-96z" />
    </svg>
  );
  const LicensureRegistrationExamHistory = () => (
    <svg className="float-end" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 100 100" fill="currentColor" style={{ fill: 'navy', height: '32px' }}>
      <path d="M63 36h11a1 1 0 0 0 1-1 1 1 0 0 0 0-1L61 20a1 1 0 0 0-1 0 1 1 0 0 0-1 1v11a4 4 0 0 0 4 4zm10 6H59a6 6 0 0 1-6-6V22a2 2 0 0 0-2-2H31a6 6 0 0 0-6 6v48a6 6 0 0 0 6 6h38a6 6 0 0 0 6-6V44a2 2 0 0 0-2-2zm-40-2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2zm30 26a2 2 0 0 1-2 2H35a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2zm4-12a2 2 0 0 1-2 2H35a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h30a2 2 0 0 1 2 2z" />
    </svg>
  );
  //END SVG ICONS


  // Enum for case labels
  const ReqEnum = {
    IDENTITY_DOCUMENT: 'Identity Documents',
    EDUCATION_HISTORY: 'Education History',
    EMPLOYMENT_HISTORY: 'Employment History',
    LICENSE_REGISTRATION: 'Licensure/Registration',
    LANGUAGE_PROFICIENCY: 'Language Proficiency',
    SPECIALTY_CERTIFICATION: 'Specialty Certifications',
    PORTFOLIO: 'Portfolio',
    LICENSURE_REGISTRATION_EXAM_HISTORY: 'Licensure/Registration Exam History',
  };

  //Doc Icons
  const RequirementICON = ({ name }) => {
    let rVal;

    switch (name) {
      case ReqEnum.IDENTITY_DOCUMENT:
        rVal = <IdentityDocuments />;
        break;
      case ReqEnum.EDUCATION_HISTORY:
        rVal = <EducationHistory />;
        break;
      case ReqEnum.EMPLOYMENT_HISTORY:
        rVal = <EmploymentHistory />;
        break;
      case ReqEnum.LICENSE_REGISTRATION:
        rVal = <LicensureOrRegistration />;
        break;
      case ReqEnum.LANGUAGE_PROFICIENCY:
        rVal = <LanguageProficiency />;
        break;
      case ReqEnum.SPECIALTY_CERTIFICATION:
        rVal = <SpecialtyCertification />;
        break;
      case ReqEnum.PORTFOLIO:
        rVal = <Portfolio />;
        break;
      case ReqEnum.LICENSURE_REGISTRATION_EXAM_HISTORY:
        rVal = <LicensureRegistrationExamHistory />;
        break;
      default:
        rVal = <div></div>;
        break;
    }

    return rVal;
  };

  const ActionRequired = () => {

    return (
      <div className="custom-font small-font">
        <div className="custom-font">
          <SucessIcon /> No Further Action Required
        </div>
        <div className="custom-font">
          <WarningIcon /> Under Review
        </div>
        <div className="custom-font">
          <ActionRequiredIcon /> Further Action Required.
        </div>
        <br />
      </div>
    );
  };


  const StatusColumn1 = ({ req, showFileUploadPopUpEmp, setShowAttestationPopUp, setShowLRAttestationPopUp, goToLPE, showFileUploadPopUpPortfolio }) => {
    const { t } = useTranslation();

    return (
      <>
        <RequirementICON name={req.RequirementCategory.Category_Type__c} />&nbsp;{req.Name_of_Requirement__c}
        {req.RequirementCategory.Category_Type__c === 'Licensure/Registration' && req.Name_of_Requirement__c === 'Self Attestation' && ' - Registration'}
        <br />{req.RequirementCategory.Category_Type__c === 'Education History' && (<span>{formatDate(req.Provided_Start_Date__c)} to {formatDate(req.Provided_End_Date__c)}</span>)}
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span className="col-4 pl-5 ml-5" style={{ padding: '0.5rem 0rem' }}>
          {req.RequirementCategory.Category_Type__c === 'Identity Documents' && req.AvailableApplication.RuleName__c !== 'BCEN' &&
            (req.Status__c === 'Waiting for Additional Documentation' ||
              req.Status__c === 'Documentation Needed' ||
              req.AvailableApplication.External_Status__c === 'Waiting for Documents' ||
              req.Status__c === 'Documentation Ready for Evaluation') &&
              req.DataDoc && req.DataDoc.Id && req.DataDoc.Box_Folder_ID__c && (
              <span>
                {`${t('Upload_Files')}`}
                <span style={{ borderRadius: '15px', padding: '0px 5px' }}>
                  <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${req.AvailableApplication.Id}&action=showFileUploadPopUp&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {t('here')} </SFLink>
                </span>
              </span>
            )}
        </span>

        <span className="col-7" style={{ padding: '0.5rem 0rem' }}>

        {req.RequirementCategory.Category_Type__c === 'Identity Documents' && req.DataDoc && req.DataDoc.Box_Shared_Folder_Link_For_Folder__c && (
            <span>
              {`${t('View_Uploaded_Files')}`}
              <a
                style={{ borderRadius: '15px', fontWeight: 'bold', textDecoration: 'underline', padding: '0px 5px' }}
                href={req.DataDoc.Box_Shared_Folder_Link_For_Folder__c}
                target="_blank"
                rel="noopener noreferrer"
              >{t('here')}</a>
              
              
            </span>
          )}
        </span>
        {req.RequirementCategory.Category_Type__c === 'Employment History' && req.AvailableApplication.RuleName__c !== 'NCNZ1' && (
          <>
            &nbsp;Request Self-Submission &nbsp;
            <div className="col-4" style={{ padding: '0.5rem 0rem' }}>
              <span style={{ borderRadius: '15px', padding: '0px 5px' }}>
                
                
                {`${t('Upload_Files')}`}
              
                  <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${req.AvailableApplication.Id}&action=showFileUploadPopUpEmp&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {t('here')} </SFLink>
              
                     
              </span>
            </div>
            <div className="col-8" style={{ padding: '0.5rem 0rem' }}>
              {req.DataDoc && req.DataDoc.Box_Shared_Folder_Link_For_Folder__c && req.DataDoc.Box_Shared_Folder_Link_For_Folder__c.length > 0 && (
                <>
                  &nbsp; {`${t('View_Uploaded_Files')}`}&nbsp;
                  <a
                    style={{
                      borderRadius: '15px',
                      fontWeight: 'bold',
                      textDecoration: 'underline',
                      padding: '0px 5px',
                    }}
                    href={req.DataDoc && req.DataDoc.Box_Shared_Folder_Link_For_Folder__c}
                    target="_blank" rel="noreferrer"
                  >
                    {t('here')}
                  </a>
                </>
              )}
            </div>
          </>
        )}
        {req.RequirementCategory.Category_Type__c === 'Employment History' && (req.Status__c === 'Documentation Needed' ||
          req.Status__c === 'Waiting for Additional Documentation' ||
          req.Status__c === 'Waiting for Authentication') && req.AvailableApplication.RuleName__c === 'NCNZ1' && !req.Self_Attestation__c && (
            <>
             Submit Self Attestation
              
                <span style={{ borderRadius: '15px', padding: '0px 5px' }}>
                 
                  <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=setShowAttestationPopUp&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {t('here')} 
                        </SFLink>
                </span>
              
            </>
          )}

        {req.RequirementCategory.Category_Type__c === 'Licensure/Registration' && req.Name_of_Requirement__c === 'Self Attestation' && (
          <>
            {(req.Status__c === 'Documentation Needed' ||
              req.Status__c === 'Waiting for Additional Documentation' ||
              req.Status__c === 'Waiting for Authentication') &&
              req.AvailableApplication.RuleName__c !== 'NCNZ1' &&
              !req.Self_Attestation__c && (
                <>
                  <br />
                  &nbsp;Submit Self Attestation
                  <div className="col-4" style={{ padding: '0.5rem 0rem' }}>
                    <span style={{ borderRadius: '15px', padding: '0px 5px' }}>                     
                        <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=setShowLRAttestationPopUp&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {t('here')} 
                        </SFLink>                      
                    </span>
                  </div>
                </>
              )}
          </>
        )}

        {req.RequirementCategory.Category_Type__c === 'Language Proficiency' && (req.Status__c === 'Documentation Needed' || req.Status__c === 'Waiting for Additional Documentation') && (
          <div>
            &nbsp;View/Update Test Information &nbsp;            
              <SFLink path={`/${portal}/s/new-profile-page?currentFormTab=Eleven`}>{t('here')} 
                </SFLink>           
          </div>
        )}
        {req.RequirementCategory.Category_Type__c === 'Portfolio' && (req.Status__c === 'Waiting for Additional Documentation' ||
          req.Status__c === 'Documentation Needed' ||
          req.AvailableApplication.External_Status__c === 'Waiting for Documents') && req.DataDoc && req.DataDoc.Id && req.DataDoc.Box_Folder_ID__c && (
            <span style={{ borderRadius: '15px', padding: '0px 5px' }}>
              {t('File_Upload')}&nbsp;              
                <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=showFileUploadPopUpPortfolio&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {`${t("click_here")}`}
                </SFLink>
              
            </span>
          )}
          <span className="col-7" style={{ padding: '0.5rem 0rem' }}>
            {req.RequirementCategory.Category_Type__c === 'Portfolio' && req.DataDoc && req.DataDoc.Box_Shared_Folder_Link_For_Folder__c && (
              <span>
              {`${t('View_Uploaded_Files')}`}
            <a
            style={{ borderRadius: '15px', fontWeight: 'bold', textDecoration: 'underline', padding: '0px 5px' }}
            href={req.DataDoc.Box_Shared_Folder_Link_For_Folder__c}
            target="_blank"
            rel="noopener noreferrer"
            >{`${t("here")}`}</a>


            </span>
            )}
            </span>
      </>




    );
  };

  const StatusColumn4 = ({ req, populateCommentModal }) => {
    const { t } = useTranslation();


    return (
      <>
        {req.Rejection_Text__c ? (
          <span>
            &nbsp;
            <button className='anchor-button' variant="a" name={req.Rejection_Text__c}  onClick={populateCommentModal} >
              {`${t('View_Comment_app_tracker')}`}
            </button> <i className="fas fa-info-circle text-info mr-2" title={`${t('HelpText_Message')}`}></i>



          </span>
        ) : (
          req.Status__c === 'Documentation Needed' ? (
            req.RequirementCategory.Category_Type__c === 'Identity Documents' ? (
              <span>
                &nbsp;
                <button className='anchor-button' variant="a" name={`${t('Documentation_Needed_Comment')}`} href="#" onClick={populateCommentModal}>
                  {`${t('View_Comment_app_tracker')}`}
                </button>
              </span>
            ) : (
              <span>
                &nbsp;
                <button className='anchor-button' variant="a" name={getFurtherActionsRequired(req)} href="#" onClick={populateCommentModal}>
                  {`${t('View_Comment_app_tracker')}`}
                </button>
              </span>
            )
          ) : (
            <span>
              &nbsp;
              <button className='anchor-button' variant="a" name={getFurtherActionsRequired(req)} href="#" onClick={populateCommentModal}>
                {`${t('View_Comment_app_tracker')}`}
              </button>
              {(req.Status__c === 'Does not Meet Requirements' ||
                req.Status__c === 'Waiting for Additional Documentation') && (
                  <span className="help-text">{`${t('HelpText_Message')}`}</span>
                )}
            </span>
          )
        )}

      </>);
  };

  const StatusColumn2 = ({ req }) => {  

    return (
      <>
        {req.External_Status__c}
        <br />
        {([ReqEnum.IDENTITY_DOCUMENT, ReqEnum.EDUCATION_HISTORY, ReqEnum.EMPLOYMENT_HISTORY, ReqEnum.LICENSE_REGISTRATION, ReqEnum.SPECIALTY_CERTIFICATION, ReqEnum.PORTFOLIO].includes(req.RequirementCategory.Category_Type__c))
          && (req.Status__c === 'Documentation Needed' || req.Status__c === 'Waiting for Additional Documentation' || req.Status__c === 'Waiting for Authentication') && (
            <>
              { !req.Reason_for_waiver__c && 
              !(ReqEnum.EMPLOYMENT_HISTORY ===req.RequirementCategory.Category_Type__c && req.AvailableApplication.RuleName__c === 'NCNZ1') &&
                !(ReqEnum.LICENSE_REGISTRATION===req.RequirementCategory.Category_Type__c && req.Name_of_Requirement__c === 'Self Attestation')
                && (
                  <>
                    <br />
                    <div>
                      Request a Waiver                      
                        <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=showWaiverModal&recId=${req.Id}`} > {t('here')} 
                        </SFLink>
                      
                    </div>
                  </>
                )}
            </>
          )}

        {ReqEnum.LANGUAGE_PROFICIENCY === req.RequirementCategory.Category_Type__c && req.ELP_Testing_Waiver__c === true && !req.Applicant_Request_Waiver__c && (
          <>
            <br />
            <div>
              Request a Waiver
              <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=showWaiverModal&recId=${req.Id}`} > {t('here')} 
              </SFLink>
            </div>            
          </>
        )}

      </>
    );
  };

  //column3 Required Forms
  const StatusColumn3 = ({ req, handleGenerateform, populateCommentModal }) => {
    const { t } = useTranslation();
    const generateFormPath = (categoryType,recId) => {
      switch (categoryType) {
        case ReqEnum.IDENTITY_DOCUMENT:
          return `/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleIDGenerateform&recId=${recId}`;
        case ReqEnum.EDUCATION_HISTORY:
          return `/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleEduGenerateform&recId=${recId}`;
        case ReqEnum.EMPLOYMENT_HISTORY:
          return `/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleEmpGenerateform&recId=${recId}`;
          case ReqEnum.LICENSE_REGISTRATION:
          return `/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleLicGenerateform&recId=${recId}`;
          case ReqEnum.SPECIALTY_CERTIFICATION:
          return `/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleSpeccertGenerateform&recId=${recId}`;
          default:
          return '';
      }
    };
    return (
      <div>
        {[ReqEnum.EDUCATION_HISTORY].includes(req.RequirementCategory.Category_Type__c)
          && req.EducationHistory && req.EducationHistory.Applicant_Directions__c && (
            <>
              <button className='anchor-button' name={req.EducationHistory.Applicant_Directions__c}
                onClick={populateCommentModal}
                style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                View Directions
              </button>
              <FaInfoCircle size="0.5em" title="Information" />
              <br />
            </>
          )}
        {[ReqEnum.LICENSE_REGISTRATION].includes(req.RequirementCategory.Category_Type__c)
          && req.LicenseRegistration && req.LicenseRegistration.Applicant_Directions__c && (
            <>
              <button className='anchor-button' name={req.LicenseRegistration.Applicant_Directions__c}
                onClick={populateCommentModal}
                style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                View Directions
              </button>
              <FaInfoCircle size="0.5em" title="Information" />
              <br />
            </>
          )}

        {([ReqEnum.IDENTITY_DOCUMENT, ReqEnum.EDUCATION_HISTORY, ReqEnum.LICENSE_REGISTRATION,
        ReqEnum.SPECIALTY_CERTIFICATION, ReqEnum.LICENSURE_REGISTRATION_EXAM_HISTORY].includes(req.RequirementCategory.Category_Type__c)
          && req.Link_to_form__c) ? (
          <a href={req.Link_to_form__c} target="_blank" rel="noopener noreferrer">
            {`${t("open_form_app_tracker")}`}
          </a>
        ) : null}

        {([ReqEnum.EMPLOYMENT_HISTORY].includes(req.RequirementCategory.Category_Type__c)
           && req.AvailableApplication && req.AvailableApplication.RuleName__c !== 'NCNZ1') && (
            <>
              {req.Applicant_to_re_generate_form__c && req.Link_to_form__c && (
                <a href={req.Link_to_form__c} target="_blank" rel="noopener noreferrer">
                  <u>{`${t("open_form_app_tracker")}`}</u>
                </a>
              )}
              {req.Link_to_form__c && <br />}
            </>
          )}
        {([ReqEnum.EMPLOYMENT_HISTORY].includes(req.RequirementCategory.Category_Type__c)
          && req.AvailableApplication && req.AvailableApplication.RuleName__c === 'NCNZ1') && (
            <div>No Form Required</div>
          )}
        <br />
        {([ReqEnum.LANGUAGE_PROFICIENCY, ReqEnum.PORTFOLIO].includes(req.RequirementCategory.Category_Type__c)) && (
          <>
            {req.Link_to_form__c && (
              <a href={req.Link_to_form__c} target="_blank" rel="noopener noreferrer">
                <u>{`${t("open_form_app_tracker")}`}</u>
              </a>
            )}
            {req.Link_to_form__c && <br />}
          </>
        )}
        {([ReqEnum.LANGUAGE_PROFICIENCY, ReqEnum.PORTFOLIO].includes(req.RequirementCategory.Category_Type__c)) && (
          <div>No Form Required</div>
        )}

        {[ReqEnum.IDENTITY_DOCUMENT, ReqEnum.EDUCATION_HISTORY, ReqEnum.EMPLOYMENT_HISTORY,
        ReqEnum.SPECIALTY_CERTIFICATION, ReqEnum.LICENSE_REGISTRATION, ReqEnum.LICENSURE_REGISTRATION_EXAM_HISTORY].includes(req.RequirementCategory.Category_Type__c)
          && req.Applicant_to_re_generate_form__c && req.Link_to_form__c && (
            <div style={{ border: '0px solid', borderRadius: '15px', padding: '0px 5px' }}>
              <Button variant="outline-primary" onClick={() => handleGenerateform(req.Id)}>
                {`${t("Generate_Form")}`}
              </Button>
              <SFLink path={generateFormPath(req.RequirementCategory.Category_Type__c,req.Id)} > {t('here')} 
              </SFLink>
            </div>
          )}          
      </div>
    );
  };

  const CriteriaColumn1 = ({ crit, req }) => {
    return (
      <>
        {crit.Rule_Name__c === 'NCNZ1' ? (
          <>
            {crit.Education_Data_Doc_Type__c === 'Copies of Diploma' ? (
              <>
                {crit.Education_Data_Doc_Type__c} and Transcript
              </>
            ) : (
              <>
                {crit.Education_Data_Doc_Type__c}
                <br />
                {req.Eligible_for_Education_Waiver__c === 'Yes' &&
                  crit.Education_Data_Doc_Type__c === 'Self Attestation' &&
                  !(crit.WaitingforAllRequiredItems__c === 'Documentation Needed') &&
                  !(crit.WaitingforAllRequiredItems__c === 'Waiting for Additional Documentation') &&
                  !(crit.WaitingforAllRequiredItems__c === 'Waiting for Authentication') &&
                  req.DataDoc.Self_Attestation__c === false &&
                  req.DataDoc.Display_Self_Attestation_Button__c === true ? (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Submit Self Attestation
                    <span className="col-4" style={{ padding: '0.5rem 0rem' }}>
                      <span style={{ borderRadius: '15px', padding: '0px 5px' }}>
                       
                          <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=setShowEduHisAttestationPopUp&recId=${crit.Data_Doc.Id}`} > {t('here')} 
                          </SFLink>
                        
                      </span>
                    </span>
                  </>
                ) : null}
              </>
            )}
          </>
        ) : (
          <>
            {crit.Education_Data_Doc_Type__c === 'Curriculum' ? (
              <span className="no-space" style={{ margin: 0, padding: 0 }}>Course Descriptions</span>
            ) : (
              crit.Education_Data_Doc_Type__c
            )}
          </>
        )}
        {crit.Accepted_Name_of_Institution__c ? (
          <> - {crit.Accepted_Name_of_Institution__c}</>
        ) : null}
        {crit.Education_Data_Doc_Type__c === 'Other' && req.Other_Check__c ? (
          <> - {req.Rejecting_Requirement_for_Other_Reason__c}</>
        ) : (
          <>
            <span className="col-4" style={{ padding: '0.5rem 0rem' }}>
              {((crit.Education_Data_Doc_Type__c === 'Copies of Diploma' || crit.Education_Data_Doc_Type__c === 'Diploma') &&
                (crit.WaitingforAllRequiredItems__c === 'Documentation Needed' ||
                  crit.WaitingforAllRequiredItems__c === 'Waiting for Additional Documentation' ||
                  crit.WaitingforAllRequiredItems__c === 'Documentation Ready for Evaluation')) ? (
                <>
                  <br />&nbsp;&nbsp;{t('File_Upload')}
                    <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=fileUploadForCopiesOfDiploma&recId=${crit.Data_Doc.Id}`} > {`${t("click_here")}`} 
                    </SFLink>
                </>
              ) : null}
            </span>
            <span className="col-8" style={{ padding: '0.5rem 0rem' }}>
              {crit.WaitingforAllRequiredItems__c !== 'Documentation Needed' && crit.Data_Doc &&
                crit.Data_Doc.Box_Shared_Folder_Link_For_Folder__c != null ? (
                crit.Education_Data_Doc_Type__c === 'Copies of Diploma' ||
                  crit.Education_Data_Doc_Type__c === 'Diploma' ? (
                  <>
                    {`${t('View_Uploaded_Files')}`}
                    <a
                      style={{
                        borderRadius: '15px',
                        fontWeight: 'bold',
                        textDecoration: 'underline',
                        padding: '0px 5px',
                      }}
                      href={crit.Data_Doc && crit.Data_Doc.Box_Shared_Folder_Link_For_Folder__c}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                     {`${t('here')}`} 
                    </a>
                  </>
                ) : null
              ) : null}
            </span>
          </>
        )}
      </>
    );
  };

  const CriteriaColumn3 = ({ crit, req }) => {
    return (
      <>
        {crit.Applicant_to_re_generate_form__c === false && crit.Link_to_form__c && (
          <a href={crit.Link_to_form__c} target="_blank" rel="noopener noreferrer">
            {/* {crit.Label.c.open_form_app_tracker} */}
            {`${t('open_form_app_tracker')}`}
          </a>
        )}
        {!crit.Link_to_form__c && crit.Education_Data_Doc_Type__c === 'Copies of Diploma' && (
          <span>No Form Required</span>
        )}
        {crit.Applicant_to_re_generate_form__c === true && crit.Link_to_form__c && (
          <div style={{ border: '0px solid', borderRadius: '15px', padding: '0px 5px' }}>
             
            <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleEduAccCriform&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {`${t('Generate_Form')}`} 
                  </SFLink>
          </div>
        )}
      </>
    );
  };

  
Object.keys(ReqEnum).forEach((key, index) => {
  sortOrder[ReqEnum[key]] = index;
});

  // Group data by Name and determine the CSS class
  const groupedData = data?.sort((a, b) => {
    const indexA = sortOrder[a.RequirementCategory.Category_Type__c] ?? Infinity;
    const indexB = sortOrder[b.RequirementCategory.Category_Type__c] ?? Infinity;
    return indexA - indexB;
  }).reduce((acc, item) => {
      acc["All Requirements"] = {
        items: [],
        allFurtherAction: true,
        anyUnderReview: false
      };
      if (!acc[item.RequirementCategory.Category_Type__c]) {
        acc[item.RequirementCategory.Category_Type__c] = {
          items: [],
          allFurtherAction: true,
          anyUnderReview: false
        };
      }

      acc[item.RequirementCategory.Category_Type__c].items.push(item);
      if (!item.showFurtherActionRquired__c) {
        acc[item.RequirementCategory.Category_Type__c].allFurtherAction = false;
        acc["All Requirements"].allFurtherAction = false;
      }
      if (item.showUnderReviewIcon__c) {
        acc[item.RequirementCategory.Category_Type__c].anyUnderReview = true;
        acc["All Requirements"].anyUnderReview = true;
      }
      return acc;
    }, {});

    const getFurtherActionsRequired = (req) => {
        
      if (req.Ava_App_Portal_Code__c === 'CGFNS-AP') {
          if (req.Status__c.toLowerCase().includes('documentation needed') || req.Status__c.toLowerCase().includes('waiting for additional documentation')) {
              if (req.Requirement_Type__c.toLowerCase().includes('language proficiency')) {
                  req.Further_Actions_Required__c = t('LP_Documentation_Needed_Message');
              } else {
                  req.Further_Actions_Required__c = t('LP_Documentation_Needed_Message');
              }
          }
          if (req.Status__c.toLowerCase().includes('meets requirement')) {
              req.Further_Actions_Required__c = t('Meets_Requirement_Message');
          }
          if (req.Status__c.toLowerCase().includes('documentation ready for evaluation')) {
              req.Further_Actions_Required__c = t('Documentation_Ready_for_Evaluation');
          }
          if (req.Status__c.toLowerCase().includes('waiting for authentication')) {
              req.Further_Actions_Required__c = t('Waiting_for_Authentication');
          }
      } else if (req.Ava_App_Portal_Code__c === 'ICD') {
          if (req.Status__c.toLowerCase().includes('documentation needed') || req.Status__c.toLowerCase().includes('waiting for additional documentation')) {
              if (req.Requirement_Type__c.toLowerCase().includes('language proficiency')) {
                  req.Further_Actions_Required__c = t('ICD_LP_Documentation_Needed_Message');
              } else {
                  req.Further_Actions_Required__c = t('ICD_Documentation_Needed_Message');
              }
          }
          if (req.Status__c.toLowerCase().includes('meets requirement')) {
              req.Further_Actions_Required__c = t('ICD_Meets_Requirement_Message');
          }
          if (req.Status__c.toLowerCase().includes('documentation ready for evaluation')) {
              req.Further_Actions_Required__c = t('ICD_Documentation_Ready_for_Evaluation');
          }
          if (req.Status__c.toLowerCase().includes('waiting for authentication')) {
              req.Further_Actions_Required__c = t('ICD_Waiting_for_Authentication');
          }
      }
  
      return req.Further_Actions_Required__c;
  };

  const RequirementTypes = ({ handleFilterChange }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    return (
      <div>
        {(!(isMobile && mobilePage===2) ) && Object.keys(groupedData).map(name => {
          const group = groupedData[name];

          return (
            <div className={name==="All Requirements" ? "d-none d-md-block table-category custom-font flex" : `table-category custom-font ${isMobile ? 'text-center' :'' }`} key={name} onClick={() => handleFilterChange(name)}>
              <div className='float-start'>{group.anyUnderReview ? <WarningIcon /> : (group.allFurtherAction ? <ActionRequiredIcon /> : <SucessIcon />)}</div> {name} <RequirementICON name={name}  />
            </div>
          );
        })}
      </div>
    );
  };



  //Percentage
  const CompletionStatus = () => {

    let total = 0;
    let completed = 0;

    percentapi.forEach(ele => {
      total += ele.Total_Requirement__c;
      completed += ele.Completed_Requirements__c;
    });



    const percentage = Math.ceil((completed / total) * 100);


    const classPercentageComplete = percentage < 100 ? "complete-percentage-red" : "complete-percentage-green";

    return (
      <p>
        {t('Percentage_complete')}:&nbsp;<span className={classPercentageComplete}>{isNaN(percentage)?'0':percentage}%</span>
      </p>
    );
  };

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
  };

  const renderRequirementRows = (req) => (
    <>
      <tr>
        <th>{t('Category_app_tracker')}</th>
        <td>{req.RequirementCategory.Category_Type__c}</td>
      </tr>
      <tr>
        <th>{t('Requirement_app_tracker')}</th>
        <td>{req.Name_of_Requirement__c}</td>
      </tr>
      <tr>
        <th>{t('Status_app_tracker')}</th>
        <td>{req.Status__c}</td>
      </tr>
      {(req.Status__c === 'Documentation Needed' || req.Status__c === 'Waiting for Additional Documentation' || req.Status__c === 'Waiting for Authentication') && (
        <>
          {!req.Reason_for_waiver__c && 
              !(ReqEnum.EMPLOYMENT_HISTORY ===req.RequirementCategory.Category_Type__c && req.AvailableApplication.RuleName__c === 'NCNZ1') &&
                !(ReqEnum.LICENSE_REGISTRATION===req.RequirementCategory.Category_Type__c && req.Name_of_Requirement__c === 'Self Attestation')
                && (
            <tr>
              <th>Request Waiver</th>
              <td className='translinks'> 
                <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=showWaiverModal&recId=${req.DataDoc?req.DataDoc.Id:null}`} >Request to waive 
                </SFLink>                 
              </td>
            </tr>
          )}
        </>
      )}
      <tr>
        <th>{t('Further_actions_app_tracker')}</th>
        <td className='translinks'>
          {req.Rejection_Text__c ? (
            <>
            <button className='anchor-button' name={req.Rejection_Text__c} href="#" onClick={populateCommentModal}>{`${t('View_Comment_app_tracker')}`}</button>
            </>
          ) : (
            <>
              {req.Status__c === 'Documentation Needed' ? (
                req.RequirementCategory.Category_Type__c === 'Identity Documents' ? (
                  <button className='anchor-button' name={`${t('Documentation_Needed_Comment')}`}  href="#" onClick={populateCommentModal}>{`${t('View_Comment_app_tracker')}`}</button>
                 
                ) : (
                  <button className='anchor-button' name={req.Further_Actions_Required__c} href="#" onClick={populateCommentModal}>{`${t('View_Comment_app_tracker')}`}</button>                 
                )
              ) : (
                <button className='anchor-button' name={req.Further_Actions_Required__c} href="#" onClick={populateCommentModal}>{`${t('View_Comment_app_tracker')}`}</button>                 
                
              )}
              {(req.Status__c === 'Does not Meet Requirements' || req.Status__c === 'Waiting for Additional Documentation') && (
                <span className="help-text">{`${t('HelpText_Message')}`}</span>
              )}
            </>
          )}
        </td>
      </tr>
      <tr>
        <th>{t('Req_Forms_app_tracker')}</th>
        <td className='translinks'>
          {req.Link_to_form__c ? (
            <a href={req.Link_to_form__c} target="_blank" rel="noopener noreferrer">
              {`${t("open_form_app_tracker")}`}
            </a>
          ) : (
            'N/A'
          )}
          {req.Applicant_to_re_generate_form__c && req.Link_to_form__c && (            
            <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleIDGenerateform&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {`${t("Generate_Form")}`} 
                  </SFLink>
          )}
        </td>
      </tr>
      {(req.Status__c !== 'Waiting for Additional Documentation' && req.Status__c !== 'Documentation Needed' && req.AvailableApplication.External_Status__c !== 'Waiting for Documents') && (
        <tr>
          <th>{t('File_Upload')}</th>
          <td className='translinks'>
          <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=showFileUploadPopUp&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {`${t("click_here")}`} 
          </SFLink>          
          </td>
        </tr>
      )}
      {req.DataDoc && req.DataDoc.Box_Shared_Folder_Link_For_Folder__c && (
        <tr>
          <th>{t('View_Uploaded_Files')}</th>
          <td className='translinks'>
            <a href={req.DataDoc.Box_Shared_Folder_Link_For_Folder__c} target="_blank" rel="noopener noreferrer">
            {t('here')}
            </a>
          </td>
        </tr>
      )}
    </>
  );

  const educationHistoryAccCriterias  = (req,eduHisAccCriterias) => (
    <>           
            <span style={{ color: 'crimson', fontSize: '1rem' }}>
            <>⇲</>
            </span> Required Documents Education History
          {eduHisAccCriterias.map(crit => (
            <React.Fragment key={crit.Id}>
              {crit.Education_Data_Doc_Type__c === 'Other' && req.Other_Check__c ? (
                req.Rejecting_Requirement_for_Other_Reason__c
              ) : (
                <Table className='text-start reqTable'>
                  <tbody>
                    <tr>
                      <th>{t('Required_File')}</th>
                      <td>
                        {crit.Rule_Name__c === 'NCNZ1' ? (
                          crit.Education_Data_Doc_Type__c === 'Copies of Diploma' ? (
                            <>
                              {crit.Education_Data_Doc_Type__c} and Transcript 
                            </>
                          ) : (
                            <>
                              {crit.Education_Data_Doc_Type__c}                              
                              {req.Eligible_for_Education_Waiver__c === 'Yes' &&
                                crit.Education_Data_Doc_Type__c === 'Self Attestation' &&
                                (crit.WaitingforAllRequiredItems__c !== 'Documentation Needed' ||
                                  crit.WaitingforAllRequiredItems__c !== 'Waiting for Additional Documentation' ||
                                  crit.WaitingforAllRequiredItems__c !== 'Waiting for Authentication') &&
                                !crit.Data_Doc.Self_Attestation__c && (
                                  <>
                                    {crit.Data_Doc.Display_Self_Attestation_Button__c && (
                                      <><br />
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t('Submit_Self_Attestation')}
                                        <span className="col-4" style={{ padding: '0.5rem 0rem' }}>
                                          <span style={{ borderRadius: '15px', padding: '0px 5px' }}>                                           
                                            <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=setShowEduHisAttestationPopUp&recId=${crit.Data_Doc.Id}`} > {t('here')}
                                            </SFLink>
                                          </span>
                                        </span>
                                      </>
                                    )}
                                  </>
                                )}
                            </>
                          )
                        ) : crit.Education_Data_Doc_Type__c === 'Curriculum' ? (
                          <span className="no-space" style={{ margin: 0, padding: 0 }}>
                            {t('Course_Descriptions')}
                          </span>
                        ) : (
                          crit.Education_Data_Doc_Type__c
                        )}
                        {crit.Accepted_Name_of_Institution__c && <> - {crit.Accepted_Name_of_Institution__c}</>}
                          {(crit.Education_Data_Doc_Type__c === 'Copies of Diploma' || crit.Education_Data_Doc_Type__c === 'Diploma') &&
                            (crit.WaitingforAllRequiredItems__c === 'Documentation Needed' ||
                              crit.WaitingforAllRequiredItems__c === 'Waiting for Additional Documentation' ||
                              crit.WaitingforAllRequiredItems__c === 'Documentation Ready for Evaluation') && (
                                <span className="col-4" style={{ padding: '0.5rem 0rem' }}><br />
                                &nbsp;
                                <span style={{ border: '1px solid', borderRadius: '15px', padding: '0px 5px' }}>                                
                                  <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=fileUploadForCopiesOfDiploma&recId=${crit.Data_Doc.Id}`} > {`${t("File_Upload")}`} 
                                  </SFLink>
                                </span>
                                </span>
                            )}
                       
                        
                          {crit.WaitingforAllRequiredItems__c !== 'Documentation Needed' && crit.Data_Doc.Box_Shared_Folder_Link_For_Folder__c && (
                           <span className="col-8" style={{ padding: '0.5rem 0rem' }}>
                              &nbsp;
                              {(crit.Education_Data_Doc_Type__c === 'Copies of Diploma' || crit.Education_Data_Doc_Type__c === 'Diploma') && (
                                <a
                                  style={{ border: '1px solid', borderRadius: '15px', padding: '0px 5px' }}
                                  href={crit.Data_Doc.Box_Shared_Folder_Link_For_Folder__c}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {t('View_Uploaded_Files')}
                                </a>
                                
                              )}
                            </span>
                          )}
                        
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Status_app_tracker')}</th>
                      <td>&nbsp;{crit.WaitingforAllRequiredItems__c}
                        {crit.showNoFurtherActionRequiredIcon__c && (
                          <div className='float-start'><SucessIcon /></div>
                        )}
                        {crit.showUnderReviewIcon__c && (
                          <div className='float-start'><WarningIcon /></div>
                        )}
                        {crit.showFurtherActionRquiredIcon__c && (
                          <div className='float-start'><ActionRequiredIcon/></div>
                        )}
                        
                      </td>
                    </tr>
                    <tr>
                      <th>{t('Req_Forms_app_tracker')}</th>
                      <td>
                        {crit.Applicant_to_re_generate_form__c === false && crit.Link_to_form__c && (
                          <a href={crit.Link_to_form__c} target="_blank" rel="noopener noreferrer">
                            {t('open_form_app_tracker')}
                          </a>
                        )}
                        {!crit.Link_to_form__c  && crit.Education_Data_Doc_Type__c === 'Copies of Diploma' && (
                          <span>No Form Required</span>
                        )}
                        {crit.Applicant_to_re_generate_form__c === true && crit.Link_to_form__c && (
                          <div style={{ border: '0px solid', borderRadius: '15px', padding: '0px 5px' }}>
                               
            <SFLink path={`/${portal}/s/application-status-tracker?applicationId=${applicationID}&action=handleEduAccCriform&recId=${req.DataDoc?req.DataDoc.Id:null}`} > {`${t('Generate_Form')}`} 
                  </SFLink>
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}<br/>
            </React.Fragment>
          ))}
        
    </>
  );

  return (
    <>  
    <AuthenticatedTemplate>   
        {isICD===true && (<button onClick={toggleLanguage} className='language-button'>
          {i18n.language === 'en' ? t('view in Français') : t('view in English')}
        </button>)}
      <div className="container-custom-color-cgfns p-4 pt-0 custom-font">
      <div className='title'>
            <h3>{t('Application_Status_Tracker')}</h3>
          </div >
          
          <div className="flex"><strong>{t('Application_Status_tabs')}</strong> <span className='strong-red' href="#">{ExtStatus}</span>
           
          </div>
          
        {isICD ===false && (
        <div className="row">        
          <div className='mt-2'>{t('Purchase_Details_app_tracker')}</div>
          <div>
            Your notarized Identity Documents can be uploaded by selecting the Upload <u><b>here</b></u>&nbsp; link below, and if any of your Education History Requirements have an Upload <em><u><b>here</b></u></em>&nbsp; link below, the Required Documents can be uploaded.
            <br />
            If there is a requirement for your order that you think is not necessary, you can request to waive this requirement by selecting the <strong><em>Request a Waiver</em></strong>&nbsp;<em><u><b>here</b></u></em>&nbsp; link below.
            <br />
            Please use the <strong><em>Submit Self Attestation</em></strong>&nbsp;<em><u><b>here</b></u></em>&nbsp; link below on your Employment History requirement to attest that the employment information that you have reported in your profile is accurate to the best of your knowledge.
          </div>
        </div>
        )}
         <div className="d-none d-md-block">
          <div className="custom-complete-text">
            <CompletionStatus />
          </div>
        
        <div className="container-custom-padding-small">

          <div className="row my-2">

            <div className="col-md-2">
              <ActionRequired />

              <RequirementTypes handleFilterChange={handleFilterChange} />

            </div>
            <div className="col-md-10 small-table">
            <div className="d-none d-md-block">            
              <table className="table table-bordered">
                <thead>
                  <tr key="fd-0">
                    <th scope="col">{t('Requirement_app_tracker')}</th>
                    <th scope="col">{t('Status')}</th>
                    <th scope="col">{t('Req_Forms_app_tracker')}</th>
                    <th scope="col">{t('Further_actions_app_tracker')}</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((item) => (
                    <tr key={item.Id}>
                      <td>
                        <StatusColumn1 req={item} />
                        {item.AcceptanceCriterias && item.AcceptanceCriterias?.filter(f => f.Education_Data_Doc_Type__c && !f.Education_Data_Doc_AC_Waived__c).length>0 && item.RequirementCategory.Category_Type__c === 'Education History' && (<p><br /><strong>Required Documents - Education History</strong><br /><ul type="disc">{item.AcceptanceCriterias && item.AcceptanceCriterias?.filter(f => f.Education_Data_Doc_Type__c && !f.Education_Data_Doc_AC_Waived__c).map((crit) => (<li key={crit.Id}><CriteriaColumn1 crit={crit} req={item} /></li>))}</ul> </p>)}
                      </td>
                      <td><StatusColumn2 req={item} />
                        {item.RequirementCategory.Category_Type__c === 'Education History' && (<p><p></p><br /><br /><strong>&nbsp;</strong><br />{item.AcceptanceCriterias && item.AcceptanceCriterias?.filter(f => f.Education_Data_Doc_Type__c && !f.Education_Data_Doc_AC_Waived__c).map((crit) => (<span key={crit.Id}>{crit.WaitingforAllRequiredItems__c}<br /></span>))} </p>)} </td>
                      <td><StatusColumn3 req={item} populateCommentModal={populateCommentModal} />
                        {item.RequirementCategory.Category_Type__c === 'Education History' && (<p className="mt-5 pt-4">{item.AcceptanceCriterias && item.AcceptanceCriterias?.filter(f => f.Education_Data_Doc_Type__c && !f.Education_Data_Doc_AC_Waived__c).map((crit) => (<span key={crit.Id}><CriteriaColumn3 crit={crit} req={item} /><br /></span>))} </p>)}</td>
                      <td><StatusColumn4 req={item} populateCommentModal={populateCommentModal} /></td>
                    </tr>                
                  ))}
                </tbody>
              </table>
            </div>     
            </div>      
          </div>
        </div>
        </div>
        <div className="d-block d-md-none">
          <br/>
            <ActionRequired />
            <div className="custom-complete-text">
            <CompletionStatus />
            </div>          
          <RequirementTypes handleFilterChange={handleFilterChange}/><br/>
        </div>
        {mobilePage ===2 && (
        <div className="d-block d-md-none">
        <div className="clearfix text-center border rounded p-3 mb-3 font-weight-bold">
      <div className="text-center mb-2"  onClick={() => handleFilterChange('')} >
        <FaArrowLeft size="16px" className="icon-success float-start" /><strong>{category}</strong>
      </div>
      

      {category === ReqEnum.IDENTITY_DOCUMENT && (
        filteredData.map((req) => (
          <Table bordered striped  key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}

      {category === ReqEnum.EMPLOYMENT_HISTORY && (
        filteredData.map((req) => (
          <Table bordered striped key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}

      {category === ReqEnum.EDUCATION_HISTORY && (
        filteredData.map((req) => (<>
          <Table bordered striped key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
            </Table>
            {req.AcceptanceCriterias  &&  req.AcceptanceCriterias?.filter(f => f.Education_Data_Doc_Type__c && !f.Education_Data_Doc_AC_Waived__c).length>0 &&(
            educationHistoryAccCriterias(req, req.AcceptanceCriterias?.filter(f => f.Education_Data_Doc_Type__c && !f.Education_Data_Doc_AC_Waived__c)))}
          </>
        ))
      )}

      {category === ReqEnum.LICENSE_REGISTRATION && (
        filteredData.map((req) => (
          <Table bordered striped key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}

      {category === ReqEnum.LICENSURE_REGISTRATION_EXAM_HISTORY && (
        filteredData.map((req) => (
          <Table bordered striped key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}

      {category === ReqEnum.LANGUAGE_PROFICIENCY && (
        filteredData.map((req) => (
          <Table bordered striped key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}

      {category === ReqEnum.SPECIALTY_CERTIFICATION && (
        filteredData.map((req) => (
          <Table bordered striped  key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}

      {category === ReqEnum.PORTFOLIO && (
        filteredData.map((req) => (
          <Table bordered striped  key={req.Id} className='text-start'>
            {renderRequirementRows(req)}
          </Table>
        ))
      )}
    </div>
        </div>)}

      </div>     
      <CommentModal show={showModal} handleClose={handleClose} content={modalContent} />
      </AuthenticatedTemplate> 
    </>
  );
}


export default CompStatusTracker;